<template>
  <div id="hotpoint-modal-container" v-if="isShow">
    <div class="dialog-box">
      <!--custom content container-->
      <div class="custom-content-container" v-if="frameInfo ===null">
        <div
          class="hot-point-content-container"
          v-for="(item, index) in info"
          :key="'info-' + index"
        >
          <div class="text-container" v-if="item.type === 'text'">
            <h2 class="title">{{ item.content.title }}</h2>
            <p class="hotpoint-text">{{ item.content.text }}</p>
          </div>
          <div class="banner-container" v-if="item.type === 'image'">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="val in item.content" :key="val">
                <div class="image-container">
                  <img :src="val" alt="" class="hotpoint-image"/>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" slot="navigation"></div>
            <div class="swiper-button-next" slot="navigation"></div>
          </div>
          <div class="video-container" v-if="item.type === 'video'">
            <video
              ref="vnVideo"
              :src="item.content"
              class="media-element"
              width="100%"
              height="100%"
              controls
              x-webkit-airplay="true"
              webkit-playsinline="true"
              x5-playsinline="true"
            ></video>
          </div>
          <div class="audio-container" v-if="item.type === 'audio'">
            <audio :src="item.content" class="media-element"></audio>
          </div>
        </div>
        <div class="close-button-container" @click="closeModal">
          <i class="iconfont icon-close"></i>
        </div>
      </div>

      <!-- web iframe container -->
      <div class="web-iframe-container" v-if="frameInfo !==null">
        <div class="web-iframe-box">
          <div class="frame-container">
            <iframe
              scrolling="no"
              :height="screenHeight * 0.8"
              class="iframeContainer"
              ref="vnIframe"
              :src="frameInfo.content"
              frameborder="no"
              border="0"
            ></iframe>
            <!--close button container-->
            <div class="close-button-container" @click="closeModal">
              <i class="iconfont icon-close"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Events } from "@/components/modeldemo/Events";
import{
  Swiper,
  SwiperSlide,
  directive
} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: "hotPoint",
  components: {
    // Carousel
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      show: false,
      carouselWidth: "400px",
      carouselHeight: 400,
      mediaHistory: new Map(),
      frameWidth: "400px",
      frameHeight: "400px",
      info: {},
      width: "400px",
      height: "400px",
      isShow: false,
      frameInfo: null,
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerview: 0,
      },
    };
  },
  computed: {
    screenHeight() {
      return Math.floor(window.screen.height);
    },
    screenWidth() {
      return Math.floor(window.screen.width);
    }
  },
  mounted() {
    let screenWidth = window.screen.width;
    if (screenWidth <= 768) {
      document.addEventListener("touchstart", e => {
        let targetElement = e.target.id;
        if (targetElement === "hotpoint-modal-container") {
          this.closeModal();
        }
      });
    } else {
      document.addEventListener("click", e => {
        let targetElement = e.target.className;
        if (targetElement === "dialog-box") {
          this.closeModal();
        }
      });
    }
    const oVideo = this.$refs.vnVideo;
    if (oVideo && oVideo[0]) {
      oVideo[0].onloadeddata = () =>{
        oVideo[0].play();
      }
    }


  },
  updated() {
    const oVideo = this.$refs.vnVideo;
    if (oVideo && oVideo[0]) {
      oVideo[0].onloadeddata = () =>{
        oVideo[0].play();
      }
    }
  },
  methods: {
    init(width, height, info) {
      this.width = width || "800px";
      this.height = height || "600px";
      this.info = info;
      this.isShow = true;
      this.info.forEach(item => {
        if (item.type === 'iframe') {
          this.frameInfo = {
            type: item.type,
            content: item.content
          }
        } else {
          this.frameInfo = null
        }
      })

      this.$nextTick(() => {
        const bannerImages = document.querySelectorAll('.hotpoint-image')
        bannerImages.forEach(item => {
          this.calcImageWidth(item)
        })
      })
    },
    // calcWidth
    calcImageWidth(img) {
      img.onload = () => {
        const imageWidth = parseInt(document.defaultView.getComputedStyle(img, null).width.split('px')[0]);
        const imageHeight = parseInt(document.defaultView.getComputedStyle(img, null).height.split('px')[0]);
        const carouselWidth = parseInt(document.querySelector('.hot-point-content-container').clientWidth);
        const carouseHeight = parseInt(document.querySelector('.hot-point-content-container').clientHeight);
        let calcWidth = carouselWidth * (imageWidth / imageHeight);
        let calcHeight = carouseHeight * (imageHeight / imageWidth);
        let screen = window.screen.width;
        if(screen <= 768) {
          imageWidth = screen*0.4;
        }
        if ((imageWidth / imageHeight) >= (carouselWidth / carouseHeight)) {
          if (imageWidth > carouselWidth) {
            calcWidth = carouselWidth;
            calcHeight = (imageHeight / imageWidth) * carouselWidth;

          } else {
            calcWidth = imageWidth
            calcHeight = imageHeight
          }
        } else {
          if (imageHeight > carouseHeight) {
            calcHeight = carouseHeight
            calcWidth = (imageWidth / imageHeight) * carouseHeight
          } else {
            calcWidth = imageWidth
            calcHeight = imageHeight
          }
        }
        img.style.width = calcWidth + 'px';
        img.style.height = calcHeight + 'px';
      }
    },
    // close
    closeModal() {
      // console.log("whgfekj")
      this.$emit(Events.HotpointClose);
      this.info = {};
      this.isShow = false;
    },
    // 获取音频视频时长，返回Promise对象
    // 使用getMediaDuration().then(res => {console.log(res)}) 获取
    getMediaDuration() {
      return new Promise(resolve => {
        setTimeout(() => {
          const targetNode = document
            .querySelector("#hotpoint-modal-container")
            .querySelectorAll(".media-element");
          const resList = [];
          if (targetNode) {
            for (let item of targetNode) {
              if (this.mediaHistory.has(item.src))
                resList.push(this.mediaHistory.get(item.src));
              else {
                const duration = Number.parseInt(item.duration);
                this.mediaHistory.set(item.src, duration);
                resList.push(duration);
              }
            }
          }
          resolve(resList);
        }, 300);
      });
    },

    // 设置网页高度
    settingIframeHeight() {

    }
  }

};
</script>

<style scoped>
#hotpoint-modal-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  height: 100%;
}

.dialog-box {
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.35);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-content-container {
  background-color: #fff;
  overflow-y: auto;
  width: 40%;
  max-width: 80%;
  min-width: 200px;
}

.custom-content-container::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.hot-point-content-container {
  width: 100%;
  height: fit-content;
  overflow: hidden;
}

.banner-container {
  width: 100%;
  height: fit-content;
  margin: 0 auto;
  margin-bottom: 0;
  position: relative;
}

.image-container {
  width: 100%;
  height: 470px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.hotpoint-image {
  /* width: 100%;
  height: 100%; */
  object-fit: contain;
}
.swiper-button-next,
.swiper-button-prev {
  color: #fff !important;
}


.banner-container >>> .ivu-carousel-item {
  display: flex;
  justify-content: center;
}

.text-container {
  width: 98%;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 20px;
}

.title {
  font-size: 18px;
}

.hotpoint-text {
  color: #555;
  text-indent: 10px;
}

.link-container {
  width: fit-content;
  height: fit-content;
  padding: 0 15px;
  float: right;
  margin: 20px 15px 10px 0;
}

.link-container a {
  width: fit-content;
  height: 25px;
  line-height: 25px;
  color: wheat;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  letter-spacing: 3px;
}

/* web iframe container */
.web-iframe-container {
  position: absolute;
  width: 82%;
  height: 82%;
  left: 8%;
  top: 5%;
}

.web-iframe-box {
  width: 100%;
  height: 100%;
}

.web-iframe-container .close-button-container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  bottom: 96%;
  left: 97.5%;
}

.custom-content-container > .close-button-container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
  cursor: pointer;
  background-color: #fff;
  position: absolute;
  bottom: 16%;
  left: calc(50% - 15px);
}



.web-iframe-container .close-button-container .icon-close {
  font-size: 18px;
  color: #efefef;
  margin: 5px auto;
}

.close-button-container .close-button-container .icon-close {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}


.frame-container {
  width: 100%;
  height: 100%;
}

.iframeContainer {
  width: 100%;
  height: 100%;
}

.video-container {
  font-size: 0;
  height: fit-content;
}

/* 新的移动端适配 */

@media screen and (max-width: 768px) {

  .custom-content-container {
    width: 100%;
    max-height: 95%;
    max-height: 80%;
  }

  .custom-content-container::-webkit-scrollbar {
    width: 0;
  }
  .custom-content-container::-webkit-scrollbar-track {
    width: 0;
  }

  .hot-point-content-container {
    width: 100%;
  }

  .hotpoint-image {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }

  .video-container {
    width: 101%;
    height: 100%;
  }

  /* web iframe container */
  .web-iframe-container {
    top: 2%;
    left: 2%;
    width: 96%;
    height: 96%;
  }

  .web-iframe-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .frame-container {
    width: 101%;
    height: 100%;
  }

  .web-iframe-container .close-button-container {
    left: 91.5%;
  }

}
</style>
